import "./App.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { APP_URLS, USER_ROLES, shouldIDoThis } from "./config";
import reqNoAuth from "./common/hoc/reqNoAuth";
import reqAuthLayout from "./common/hoc/reqAuth";

import {
  ResetPasswordPage,
  LoginPage,
  ProfilePage,
  AdminDashboardPage,
  AgentDashboardPage,
  TeamLeadDashboardPage,
  ListAttendancePage,
  MyAttendancePage,
  UsersListPage,
  UsersDetailPage,
  EmployeesListPage,
  EmployeesDetailPage,
  HrDashboardPage,
  OrganizationDetailsPage,
  OrganizationSecurityPage,
  OrganizationSettingsPage,
  ApplicationListingPage,
  CreateApplicationPage,
  ViewAndUpdateApplicatinForm,
  ProspectsListPage,
  ProspectsViewPage,
  AllProspectsListPage,
  ProspectsOpenPage,
  EditApplicationPage,
  AllUserCalendar,
  AllLeavesPage,
  MyLeavesPage,
  ConversationPage,
  PayslipCreate,
  Report,
  PayslipPringPage,
  AllConversationPage,
} from "./pages";

import { useSelector } from "react-redux";
import { userDetailsSelector } from "./rdxsga/redux/slices/userSlice";
import { Bounce, Flip, Slide, ToastContainer } from "react-toastify";
import { useDarkMode } from "./rdxsga/hooks/common/useDarkMode";
import DefaultPage from "./pages/DefaultPage";
import MobileNotAllowed from "./components/extras/MobileNotAllowed";
import RippleButton from "./components/common/RippleButton";
import Settings from "./pages/Settings";
import { askForNotificationPermission } from "./helpers/notification";
import Payslip from "./pages/Payslip/payslipv2/Payslip";
import ShowRemainderModel from "./components/common/modals/ShowRemainderModel";



function isMobileFromUserAgent() {
  return /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 768;
  return /Mobi|Android/i.test(navigator.userAgent);
  const userAgent = navigator.userAgent;
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );

  return isMobile;
}

function isMobileDevice() {
  // Check if the user agent contains any mobile keywords
  if (/Mobi|Android/i.test(navigator.userAgent)) {
    return true;
  }

  // Check if the screen width is less than or equal to a certain threshold
  // if (window.innerWidth <= 768) {
  //   return true; // Adjust the threshold as needed
  // }

  // Check if touch events are supported (typically mobile devices support touch)
  // if ('ontouchstart' in window || navigator.maxTouchPoints && window.innerWidth <= 768) {
  //   return true;
  // }

  // Default: Not a mobile device
  return false;
}

function App() {
  const users = useSelector(userDetailsSelector);
  const darkMode = useDarkMode();




  console.log({ env: process.env.REACT_APP_ENVIRONMENT });

  // PRODUCTION CODE FOR REMOVING CONSOLE LOG OR ANY OTHER MESSAGE FROM CONSOLE
  if (process.env.REACT_APP_ENVIRONMENT == 'prod') {
    console.log = () => { };
    console.debug = () => { };
    console.info = () => { };
    console.warn = () => { };
  }



  useEffect(() => {
    if (users?.isAuthenticated) {
      askForNotificationPermission();
    }
  }, [users])





  const getUsersDashboard = () => {
    if (users?.user?.role === USER_ROLES.SUPER_ADMIN) return AdminDashboardPage;
    else if (users?.user?.role === USER_ROLES.ADMIN) return AdminDashboardPage;
    else if ([USER_ROLES.ASSOCIATE, USER_ROLES.CUSTOMER_SERVICE].includes(users?.user?.role))
      return AgentDashboardPage;
    else if (users?.user?.role === USER_ROLES.TEAM_LEAD)
      return TeamLeadDashboardPage;
    else if (users?.user?.role === USER_ROLES.HR) return HrDashboardPage;
    else return DefaultPage;
  };

  if (isMobileDevice()) {
    return <MobileNotAllowed />;
  } else
    return (
      <BrowserRouter>
        {/* <RippleButton >Hello</RippleButton> */}
        <Routes>
          <Route path={APP_URLS.LOGIN} element={reqNoAuth(LoginPage)} />
          <Route
            path={APP_URLS.RESET_PASSWORD}
            element={reqNoAuth(ResetPasswordPage)}
          />

          <Route
            path={APP_URLS.PROFILE}
            element={reqAuthLayout(ProfilePage, [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD,

            ])}
          />

          <Route
            path={APP_URLS.DASHBOARD}
            element={reqAuthLayout(getUsersDashboard(), [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD,
            ])}
          />

          <Route
            path={APP_URLS.CONVERSATION.ROUTE}
            element={reqAuthLayout(ConversationPage, [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD,
            ])}
          />


          <Route
            path={APP_URLS.CONVERSATION.ALL}
            element={reqAuthLayout(AllConversationPage, [
              USER_ROLES.SUPER_ADMIN,
              USER_ROLES.ADMIN,
              USER_ROLES.HR
            ])}
          />

          <Route
            path={APP_URLS.PROSPECTS.ROUTES}
            element={reqAuthLayout(ProspectsListPage, [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.TEAM_LEAD,
            ])}
          />


          <Route
            path={APP_URLS.PROSPECTS.ALL}
            element={reqAuthLayout(AllProspectsListPage, [
              USER_ROLES.TEAM_LEAD,
            ])}
          />
          <Route
            path={APP_URLS.PROSPECTS.OPEN}
            element={reqAuthLayout(ProspectsOpenPage, [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.TEAM_LEAD,
            ]
            )}
          />
          <Route
            path={APP_URLS.PROSPECTS.VIEW}
            element={reqAuthLayout(ProspectsViewPage, [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.TEAM_LEAD,
            ])}
          />

          <Route
            path={APP_URLS.ATTENDANCE.ROUTE}
            element={reqAuthLayout(MyAttendancePage, [

              USER_ROLES.ASSOCIATE,
              USER_ROLES.HR,

              USER_ROLES.TEAM_LEAD,
            ])}
          />
          <Route
            path={APP_URLS.REPORT}
            element={reqAuthLayout(Report, [
              USER_ROLES.HR
            ])}
          />
          <Route
            path={APP_URLS.ATTENDANCE.LIST}
            element={reqAuthLayout(ListAttendancePage, [
              USER_ROLES.TEAM_LEAD,
              USER_ROLES.HR,

            ])}
          />

          <Route
            path={APP_URLS.CALENDAR.ROUTE}
            element={reqAuthLayout(AllUserCalendar, [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD,
            ])}
          />
          <Route
            path={APP_URLS.LEAVES.ROUTE}
            element={reqAuthLayout(MyLeavesPage, [
              USER_ROLES.ASSOCIATE,
              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD,
            ])}
          />
          <Route
            path={APP_URLS.LEAVES.ALL}
            element={reqAuthLayout(AllLeavesPage, [
              USER_ROLES.TEAM_LEAD,
              USER_ROLES.HR,
            ])}
          />

          <Route
            path={APP_URLS.USERS.ROUTE}
            element={reqAuthLayout(UsersListPage, [

              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD,
            ])}
          />
          <Route
            path={APP_URLS.USERS.DETAILS}
            element={reqAuthLayout(UsersDetailPage, [

              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD

            ])}
          />


          <Route
            path={APP_URLS.PAYSLIP.ROUTE}
            element={reqAuthLayout(PayslipCreate, [
              USER_ROLES.HR,
            ])}
          />


          <Route
            path={APP_URLS.PAYSLIP.SPECIFIC}
            element={reqAuthLayout(PayslipPringPage, [
              USER_ROLES.HR,
              USER_ROLES.TEAM_LEAD,
              USER_ROLES.ASSOCIATE,
              USER_ROLES.ADMIN
            ])}
          />

          <Route
            path={APP_URLS.EMPLOYEES.ROUTE}
            element={reqAuthLayout(EmployeesListPage, [
              USER_ROLES.HR,

            ])}
          />
          <Route
            path={APP_URLS.EMPLOYEES.DETAILS}
            element={reqAuthLayout(EmployeesDetailPage, [
              USER_ROLES.HR,

            ])}
          />

          <Route
            path={APP_URLS.APPLICATION.ROUTE}
            element={reqAuthLayout(ApplicationListingPage, [

              USER_ROLES.TEAM_LEAD,
              USER_ROLES.ASSOCIATE
            ])}
          />
          <Route
            path={APP_URLS.APPLICATION.CREATE}
            element={reqAuthLayout(CreateApplicationPage, [
              USER_ROLES.TEAM_LEAD,
              USER_ROLES.ASSOCIATE
            ])}
          />
          <Route
            path={APP_URLS.APPLICATION.VIEW}
            element={reqAuthLayout(ViewAndUpdateApplicatinForm, [
              USER_ROLES.TEAM_LEAD,
              USER_ROLES.ASSOCIATE
            ])}
          />
          <Route
            path={APP_URLS.APPLICATION.EDIT}
            element={reqAuthLayout(EditApplicationPage, [
              USER_ROLES.TEAM_LEAD,
              USER_ROLES.ASSOCIATE
            ])}
          />

          <Route
            path={APP_URLS.ORGANIZATION.ROUTE}
            element={reqAuthLayout(OrganizationDetailsPage)}
          />
          <Route
            path={APP_URLS.ORGANIZATION.SECURITY}
            element={reqAuthLayout(OrganizationSecurityPage)}
          />
          <Route
            path={APP_URLS.ORGANIZATION.SETTINGS}
            element={reqAuthLayout(OrganizationSettingsPage, [
              USER_ROLES.HR,
            ])}
          />


          {/* <Route
            path="/whatwillyoudoafterthis"
            element={<Payslip />}
          /> */}
        </Routes>

        {/* Modals and Containers */}



        <ToastContainer
          position="top-center"
          autoClose={5000}
          style={{
            zIndex: 99999999
          }}
          newestOnTop
          hideProgressBar
          transition={
            shouldIDoThis() ? (shouldIDoThis() ? Flip : Bounce) : Slide
          }
          theme={shouldIDoThis() ? "colored" : darkMode ? "dark" : "light"}
        />
      </BrowserRouter>
    );
}

export default App;
